import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';

import Icon from 'components/UI/Icon';
import './styles.scss';

SwiperCore.use(Pagination);

const SwiperContainer = ({ data }) => (
  <div className="cr-features-mob-swiper cr-swiper-controls-pagination ">
    <Swiper pagination>
      {data.map((slide, index) => (
        <SwiperSlide
          key={index}
          className={classnames('cr-features-mob-swiper_item')}
        >
          <Link
            to={slide.featuresListLink.uri}
            className={classnames('cr-features-mob-swiper_link')}
          >
            <p className={classnames('cr-features-mob-swiper_icons-wrap')}>
              <img src={slide.featuresListIcon?.sourceUrl} alt="" />
              <Icon name={'corner-arrow-small'} />
            </p>

            <h3 className={classnames('cr-features-mob-swiper_title cr-h3')}>
              {slide.featuresListTitle}
            </h3>

            <p>{slide.featuresListDescription}</p>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
);

export default SwiperContainer;
